<div class="h-32 overflow-y-auto text-gray-600 italic">
  @for (item of legalTextData().text; track item) {
    <p>
      @for (part of parseText(item); track part) {
        @if (!isLink(part)) {
          {{ part }}
        } @else {
          <a [href]="part?.href" [target]="part?.target">{{ part?.text }}</a>
        }
      }
    </p>
    <br />
  }
</div>
